import { render, staticRenderFns } from "./RecommendedIngredient.vue?vue&type=template&id=78f569f0&scoped=true"
import script from "./RecommendedIngredient.vue?vue&type=script&lang=js"
export * from "./RecommendedIngredient.vue?vue&type=script&lang=js"
import style0 from "./RecommendedIngredient.vue?vue&type=style&index=0&id=78f569f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f569f0",
  null
  
)

export default component.exports